import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/DouglasXiao',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.facebook.com/douglas.xiao.5',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.instagram.com/rockdouglas_2020/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://www.linkedin.com/in/ke-xiao-b9b74b128',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://twitter.com/Douglas01688816',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'https://www.youtube.com/channel/UCqjb737VGLK0wsFWAgSwgmg',
    label: 'Youtube',
    icon: faYoutube,
  },
  {
    link: 'mailto:luckyxiaoke@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
